import { useContext, useEffect } from "react"
import { useHistory } from "react-router"
import AppContext from "~/contexts/App"
import { permissionAllowed } from "~/utils/permissionAllowed"

const usePermissionsRedirect = (url, permissionType, permissionGroup) => {
  const { authUser } = useContext(AppContext)
  const history = useHistory()

  useEffect(() => {
    if (!authUser) {
      return
    }

    const {
      permissions: userPermissions,
      permission_group: userPermissionGroup,
    } = authUser

    let allowed = false
    if (userPermissionGroup === "super") {
      allowed = true
    } else {
      allowed = permissionAllowed(
        permissionGroup,
        userPermissionGroup,
        permissionType,
        userPermissions,
      )
    }

    if (!allowed) {
      history.push(url)
    }
  }, [authUser])
}
export default usePermissionsRedirect
